/**
 * eQuote Color Tokens - Manulife theme
 */

export const colors = {
  // Primary (Manulife dark blue)
  primary:           '#003366',
  primaryContainer:   '#002244',
  onPrimary:         '#ffffff',
  onPrimaryContainer: '#e6f0fa',

  white: '#ffffff',
  black: '#000000',

  // Secondary (Manulife green)
  secondary:           '#00A651',
  secondaryContainer:  '#008540',
  onSecondary:         '#ffffff',
  onSecondaryContainer:'#e6fbf0',

  // Tertiary (Accent orange)
  tertiary:            '#FF6B00',
  tertiaryContainer:   '#cc5500',
  onTertiary:          '#ffffff',
  onTertiaryContainer:  '#fff0e6',

  // Error
  error:           '#ba1a1a',
  errorContainer:  '#ffdad6',
  onError:         '#ffffff',
  onErrorContainer: '#93000a',

  // Surface hierarchy
  surface:                  '#f5f7fa',
  surfaceBright:            '#f5f7fa',
  surfaceContainerLowest:   '#ffffff',
  surfaceContainerLow:      '#edf1f5',
  surfaceContainer:         '#e4ebf0',
  surfaceContainerHigh:     '#dbe4eb',
  surfaceContainerHighest:  '#d2dce6',
  surfaceDim:               '#ccd7e0',
  surfaceVariant:           '#d2dce6',

  // On surfaces
  onSurface:            '#1a1a1a',
  onSurfaceVariant:     '#666666',
  onBackground:         '#1a1a1a',
  background:           '#f5f7fa',

  // Outline
  outline:     '#b0c4de',
  outlineVariant: '#dcdcdc',

  // Inverse
  inverseSurface:    '#2e3036',
  inverseOnSurface:  '#f0f0f7',
  inversePrimary:    '#a6c8ff',

  // Fixed variants
  primaryFixed:             '#d5e3ff',
  primaryFixedDim:         '#a8c8ff',
  onPrimaryFixedVariant:   '#003366',
  secondaryFixed:          '#d5fbe6',
  secondaryFixedDim:       '#a8f8cc',
  tertiaryFixed:           '#ffdcd5',
  tertiaryFixedDim:        '#ffb4a9',

  surfaceTint: '#003366',
} as const;

export type ColorKey = keyof typeof colors;
